<script>
export default {
  props: {
    message: { type: String, default: '' },
    action: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      toggleAfterTimeout: false,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<template>
  <div>
    <div
      class="shadow-sm bg-n-slate-12 dark:bg-n-slate-7 rounded-lg items-center gap-3 inline-flex mb-2 max-w-[25rem] min-h-[1.875rem] min-w-[15rem] px-6 py-3 text-left"
    >
      <div class="text-sm font-medium text-white dark:text-white">
        {{ message }}
        <template v-if="action && action.type === 'multi-link'">
          <router-link
            v-for="link in action.links"
            :key="link.to"
            :to="link.to"
            class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand ml-1"
          >
            {{ link.label }}
          </router-link>
        </template>
      </div>
      <div v-if="action && action.type === 'link'">
        <router-link
          :to="action.to"
          class="font-medium cursor-pointer select-none text-n-blue-10 hover:text-n-brand"
        >
          {{ action.message }}
        </router-link>
      </div>
    </div>
  </div>
</template>
